import { t } from "i18next";
import {
  MdAlignHorizontalLeft,
  MdAlignVerticalTop,
  MdRefresh,
} from "react-icons/md";
import CircleButton from "widgets/controls/buttons/circle-button";
import { SearchInput } from "widgets/shared/inputs/search";

export class SearchPanelControl {
  fitsScreenCounter = 0;
  expandAllCounter = 0;
  collapseAllCounter = 0;
}

type SearchPanelProps = {
  id?: string;
  title?: string;
  type?: string;
  onSearch?: (search: string) => void;
  direction?: "TB" | "LR";
  onDirectionChange?: (direction: "TB" | "LR") => void;
  onRefresh?: () => void;
};

// Define the ProgressButton component with destructured props
export const OrgChartSearchPanel = (props: SearchPanelProps) => {
  const { id, title, type, direction, onDirectionChange, onSearch, onRefresh } =
    props;

  const handleSearch = (search: string) => {
    onSearch?.(search);
  };

  return (
    <div
      id={id}
      className="flex w-full flex-col rounded-[20px] border bg-white px-5 py-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="text-lg font-bold text-primary">
            {title} - {type}
          </div>
          <div className="flex w-[300px] items-center gap-4">
            <SearchInput
              sizes="md"
              value=""
              placeholder={t("generic.search.reactflow") + "..."}
              clearIcon={true}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <CircleButton
            onClick={onRefresh}
            icon={MdRefresh}
            size="md"
            color="secondary"
            variant="ghost"
            tooltip={t("tooltip.refresh")}
            tooltipPlacement="bottom"
          />
          <CircleButton
            onClick={() =>
              onDirectionChange?.(direction === "LR" ? "TB" : "LR")
            }
            icon={
              direction === "LR" ? MdAlignVerticalTop : MdAlignHorizontalLeft
            }
            tooltip={
              direction === "LR" ? "Vertical layout" : "Horizontal layout"
            }
            color="primary"
            variant="outline"
            size="md"
            extra="rounded-lg "
          />
        </div>
      </div>
    </div>
  );
};

export default OrgChartSearchPanel;
